<template>
  <v-row justify="center">
    <v-dialog
        v-model="dialog"
        max-width="70%"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5 align-center">Operadora (Regra de Aceitação) - Listar</span>
          <v-col class="d-flex flex-row justify-end">
            <v-btn small @click="loadData">
              <v-icon small title="Buscar">fas fa-search</v-icon>
            </v-btn>
            <v-btn class="mx-1" small @click="add" v-show="items && items.length">
              <v-icon small title="Adicionar">fas fa-plus</v-icon>
            </v-btn>
            <v-btn small @click="hide">
              <v-icon small title="Fechar">fas fa-window-close</v-icon>
            </v-btn>
          </v-col>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="dialogForm">
              <v-row>
                <v-col cols="4">
                  <v-text-field
                      dense
                      label="CNPJ"
                      v-model="carrier.cnpj"
                      v-mask="$util.formmasks.cnpj"
                      :clearable="true"
                      outlined
                  />
                </v-col>
                <v-col cols="8">
                  <v-text-field
                      dense
                      label="Razão Social"
                      v-model="carrier.razaoSocial"
                      :clearable="true"
                      outlined
                  />
                </v-col>
                <v-col cols="8">
                  <v-text-field
                      dense
                      label="Nome Fantasia"
                      v-model="carrier.name"
                      :clearable="true"
                      outlined
                  />
                </v-col>
                <v-col cols="4">
                  <v-select
                      dense
                      outlined
                      v-model="carrier.benefitId"
                      :items="benefits"
                      item-text="name"
                      item-value="id"
                      label="Benefício"
                      :clearable="true"
                      :loading="this.benefits.length == 0"
                  ></v-select>
                </v-col>
              </v-row>
            </v-form>
            <v-data-table
                v-if="items"
                v-model="selected"
                :headers="headers"
                :items="items"
                :loading="isSearching"
                item-key="id"
                locale="pt-BR"
                show-select
                class="elevation-1 mt-2"
            >
            </v-data-table>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import BenefitService from "@/services/odoo/BenefitService";
import CarrierService from "@/services/odoo/CarrierService";

let initialData = {
  selected: [],
  items: null,
  totalElements: 0,
}

export default {
  props: {
    acceptanceRuleId: {
      type: String
    },
  },
  data() {
    return {
      dialog: false,
      carrier: {},
      benefits: [],
      headers: [
        { text: 'CNPJ', align: 'right', value: 'cnpj'},
        { text: 'Nome Fantasia', value: 'name'},
        { text: 'Razão Social', value: 'razaoSocial'}
      ],
      isSearching: false,
      options: {},
      singleSelect: false,
      ...initialData
    };
  },
  async created() {
    this._benefitService = new BenefitService();
    this._carrierService = new CarrierService();
  },
  watch: {
    'carrier.cnpj'(val) {
      if (val && val !== val.toUpperCase()) {
        this.carrier.cnpj = val.toUpperCase();
      }
    },
    options: {
      handler() {
        this.loadData()
      },
      deep: true,
    },
  },
  methods: {
    resetData() {
      if (this.$refs.dialogForm)
        this.$refs.dialogForm.reset();

      for (const prop in initialData) {
        this[prop] = initialData[prop];
      }
    },
    async loadData() {
      this.isSearching = true
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      const { data } = await this._carrierService.findAllByParams(
          Object.assign(
            this.carrier,
              {
                exceptAcceptanceRuleId: this.acceptanceRuleId,
                page: page ? page - 1 : 0,
                sortBy: sortBy && sortBy.length? sortBy[0] : 'cnpj',
                descending: sortDesc && sortDesc.length? sortDesc[0] : false,
                size: itemsPerPage
              }
          )
      )
      this.items = data.content;
      this.totalElements = data.totalSize;
      this.isSearching = false;
      this.$emit('on-load')
    },
    show() {
      this.resetData();
      this.dialog = true;
      if (this.benefits.length) return;
      this._benefitService.findAll().then((res) => this.benefits = res.data.records);
    },
    hide() {
      this.dialog = false;
    },
    add() {
      this.$emit('selected', this.selected)
      this.items = [];
      this.hide();
    }
  }
};
</script>
